import { getOperationalModuleSlug } from "@shared/api/server/gs3Server";

const generalModuleSlug = getOperationalModuleSlug("General");

/**
 * Rotas onde o Google Maps JS API está montado. Trocar idioma exige reload completo
 * da página — a API não permite reinicializar language/region na mesma sessão.
 */
export const shouldReloadPageOnGoogleMapsRoute = (pathname: string): boolean => {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";

  if (normalizedPath === "/roadmap") {
    return true;
  }

  if (!generalModuleSlug) {
    return false;
  }

  const generalStructurePathPrefix = `/${generalModuleSlug}/`;
  if (!normalizedPath.startsWith(generalStructurePathPrefix)) {
    return false;
  }

  const structureSegment = normalizedPath.slice(generalStructurePathPrefix.length);
  return structureSegment.length > 0 && !structureSegment.includes("/");
};
